import apiV2 from "api-v2";

const getRFQServices = async (email) => {
	return await apiV2.post(`/guest`, {
		email: email,
	});
};
const guestFirstLoggedServices = async (email, hasAccepted) => {
	return await apiV2.post(`/guest/first-logged`, {
		hasAccepted: hasAccepted,
		email: email,
	});
};
export { getRFQServices, guestFirstLoggedServices };
